import { useMutation, useQueryClient } from 'react-query';
import request from '../../../../helpers/request';
import { getQueryTransportKeys } from '../getQueryTransportKeys';

const deleteAttachments = async (value) => {
  return request.delete(
    '/HousingStock/transport/attachments',
    value,
    'При удалении документа ТС произошла ошибка',
    'Error'
  );
};

const useDeleteAttachments = () => {
  const queryClient = useQueryClient();

  return useMutation(deleteAttachments, {
    onSuccess: (data, { transportId }) => {
      if (data === 'Error') return;

      queryClient.invalidateQueries(
        getQueryTransportKeys.transportDocs(transportId)
      );
    },
  });
};

export default useDeleteAttachments;
